// angular dependencies
import { Injectable, inject } from '@angular/core';

// third-party dependencies
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

// fantaz dependencies
import { environment } from '@fantaz/shared/app-config';
import { TrackError } from '../../../utils/track-error.service';
import * as CoreErrorTrackActions from './error-track.actions';

@Injectable()
export class CoreErrorTrackEffects {
  #actions: Actions = inject(Actions);

  showDialogMessage$ = createEffect(
    () =>
      this.#actions.pipe(
        ofType(CoreErrorTrackActions.trackError),
        tap(({ error }) => {
          if (!environment.production) {
            console.group('CoreErrorTrackEffects');
            console.error(error);
            console.groupEnd();
          }
          TrackError.trackError(error);
        }),
      ),
    { dispatch: false },
  );
}
